/**
 * Layout breakpoints for mobile/desktop detection.
 *
 * IMPORTANT: These values must stay in sync with tailwind.config.js screens.
 * The `desktop` screen in Tailwind uses DESKTOP_BREAKPOINT.
 *
 * Mobile: < 1024px (phones, tablets in portrait including iPad Pro 11")
 * Desktop: >= 1024px (tablets in landscape, laptops, desktops)
 */
export const DESKTOP_BREAKPOINT = 1024;

/**
 * Media query strings for use with window.matchMedia() or useMediaQuery hook.
 */
export const MEDIA_QUERIES = {
  mobile: `(max-width: ${DESKTOP_BREAKPOINT - 1}px)`,
  desktop: `(min-width: ${DESKTOP_BREAKPOINT}px)`,
} as const;
